module.exports = __webpack_public_path__ + "static/DoneByHumans-16848dbbbe1f08aa99bb9eaf007b0a43.png";